import PropTypes from 'prop-types';
import React from 'react';
import IncentiveLink from './IncentiveLink';

class IncentiveDetail extends React.Component {
	constructor(props) {
		super(props);
		this.showModalData = this.showModalData.bind(this);
	}

	showModalData(incentive, isModalVisible) {
		this.props.setModalStateData(incentive, isModalVisible);
	}

	render() {
		const { incentives } = this.props;
		const body = incentives.map(incentive => {
			const { key } = incentive;

			return (
				<IncentiveLink
					key={`${key}b`}
					incentive={incentive}
					showModalData={this.showModalData}
				/>
			);
		});
		return (
			<ul className="list-unstyled line-height-condensed mb-0">{body}</ul>
		);
	}
}

IncentiveDetail.propTypes = {
	incentives: PropTypes.arrayOf(
		PropTypes.shape({
			key: PropTypes.string,
			title: PropTypes.string,
			label: PropTypes.string,
			offerDetails: PropTypes.string,
			shortTitle: PropTypes.string,
			disclaimer: PropTypes.string,
			effectiveDate: PropTypes.string,
			expirationDate: PropTypes.string,
			conditional: PropTypes.bool
		}).isRequired
	).isRequired,
	setModalStateData: PropTypes.func.isRequired
};

export default IncentiveDetail;



// WEBPACK FOOTER //
// ./src/components/IncentiveDetail.jsx